<template>
  <div class="intelligentAgriculture-page">
    <!-- 数字乡村-->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    	<div class="main">
            <div class="top-banner">
                <h2 style="font-size: 46px;font-weight: 500;position: absolute;color: #fff;left: 15%;top: 240px;text-shadow: 3px 3px 3px #2c3e50;">高标准农田建设方案</h2>
                <h2 style="font-size: 32px;font-weight: 500;position: absolute;color: #fff;left: 15%;top: 320px;">High standard farmland construction scheme</h2>
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/high_standard_farmland/banner.png">            
            </div>

          <div class="mid-body" style="background:#fff;margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">高标准农田建设项目—农渠灌溉</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666;text-align:center;line-height:32px">通过物联网远程控制水泵开关，将水源输送至高水位池，利用地势差让水源通过明渠引流至农田进行灌溉。通过水位计、流量计、土壤传感器等物联网设备在线监测农田灌溉情况。</p>                                                                       
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/high_standard_farmland/index01.png">                                             
                    </div>
                </div>    
            </div> 
             <div class="mid-body" style="background:#fff;margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">高标准农田建设项目—电磁灌溉</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666;text-align:center;line-height:32px">通过土壤墒情物联网设备在线监测各地块灌溉情况，大数据分析当前农作物水环境状态，数据实施反馈，通过远程联动控制水泵及各支路电磁阀门对目标地块的给排水作业，实现高标准农田灌溉精细化管理。</p>                                                                       
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/high_standard_farmland/index02.png">                                             
                    </div>
                </div>    
            </div> 
            <div class="mid-body" style="background:#fff;margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">高标准农田流量计</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666;text-align:center;line-height:32px">高标准农田渠道监测装置，可用于输水渠（续水渠）包括支渠、斗渠、分渠；还有灌溉渠、轮灌渠水资源在线监测，可有效监测到灌溉渠道跑、冒、漏的情况。</p>                                                                       
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/high_standard_farmland/index03.png">                                             
                    </div>
                </div>    
            </div>  
            <div class="mid-body" style="background:#fff;margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">田间气象、病虫害监测、设施农业</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666;text-align:center;line-height:32px">更多物联网设备的发展与运用，推进了高标准农田建设的高速发展。</p>                                                                       
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/high_standard_farmland/index04.png">                                             
                    </div>
                </div>    
            </div>  
            <div class="mid-body" style="background:#fff;margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">百倍云数字农业大数据综合管控中心</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666;text-align:center;line-height:32px">实时监测田园地块环境信息，可视化调取各地块水肥等环境数据，通过数据分析，远程灌溉等实现大田灌溉自动化，智能化，提高大田生产效率，降低生产成本。</p>                                                                       
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/high_standard_farmland/index05.png">                                             
                    </div>
                </div>    
            </div>          
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {
        select:1,
    }
  },
  mounted() {
  },
  methods: {
      clicknav(e){
          this.select = e
      }
  }
}
</script>
<style>
    .banner-title{
        width: 490px;
        height: 120px;
        position: absolute;
        top: 50%;
        right: 50%;
        margin-top: 40px;
    }
    .mid-body{
        margin-bottom: 120px;
    }
    .mid-body-box{
        width: 1200px;
        margin: auto;
        position: relative;
    }
    .four-box{
        width: 25%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
    }
    .list-box{
     box-sizing: border-box;
    padding: 20px;
    position: relative;
    text-align: left;
    padding-left: 240px;
        
    }
    .list-box img{
        width: 24px;
        height: auto;
        position: absolute;
        left: 190px;
        top: 21px;
    }
     .list-box p{
        margin-bottom: 14px;
    }
    .five-box{
        width: 20%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
        padding-bottom: 0;
    }
    .five-box img{
            width: 50px;
    height: auto;
    margin: auto;
    cursor: pointer;
    }
        .five-box span{
         display: inline-block;
        padding-top: 22px;
        padding-bottom: 32px;
        font-size: 18px;
        font-weight: bold;
        color: #8993a7;
        line-height: 1em;
        border-bottom: 3px solid transparent;
        cursor: pointer;
    }
   
    .three-box{
        width: 30%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
        background: #fff;
        height: 430px;
        margin: 1.6%;
    }
    .left-box{
        width: 50%;
        float: left;
        text-align: left;
        box-sizing: border-box;
        padding: 74px;
    }c

    .nav-box{
        width: 100%;
        border: 1px solid #dbe0e5;
        box-sizing: border-box;
        padding: 40px;
    }
    .nav-box .list{
        width: 100%;
        margin-bottom: 20px;
        text-align: left;
    }
    .list-item{
        padding: 12px 20px;
        color: #8993a7;
        margin-right: 20px;
        margin-bottom: 20px;
        display: inline-block;
        background: #ffffff;
        border: 1px solid #d0d7e1;
        -webkit-box-shadow: 0px 3px 7px 0px rgba(189, 230, 202, 0.35);
        box-shadow: 0px 3px 7px 0px rgba(189, 230, 202, 0.35);
        min-width: 120px;
        text-align: center;
        position: relative;
            font-size: 12px;
    width: 150px;
    }
    .img_index03{
        width:223px;
        height:auto;
        position:absolute;
        right: 405px;
        top: 97px;
        z-index: 2;
    }

    .img_index04{
        width: auto;
        height: 94%;
        position: absolute;
        top: 0;
        right: 65%;
        margin-top: 1%;
    }
        .img_index06{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: 97px;
        z-index: 2;
    }
    .img_index07{
    width: 223px;
    height: auto;
    position: absolute;
    left: 165px;
    top: 229px;
    z-index: 2;
    }
    .img_index09{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: -205px;
        z-index: 2;
    }
    .active{
        border-bottom: 3px solid #f8a811 !important;
        color: #333 !important;
    }
        .left-cbox{
        width: 50%;
        float: left;
        text-align: left;
        box-sizing: border-box;
        padding: 34px;
    }
    .right-box{
        float: left;
        width: 50%;
            padding: 25px;
    background: #FFFFFF;
    box-shadow: 0px 0px 31px 1px rgba(14, 5, 10, 0.04);
    height: 248px;
       
    }
    .right-box  h3{
        width: 100%;
            margin-bottom: 20px;
        }
        .fourbox{
            float: left;
            width: 21%;
            margin: 2%;
            background: #fff;
            border: 1px solid #1AB334;
            box-sizing: border-box;
            padding: 10px;
            height: 220px;
        }
        .fourbox img {
            margin: auto;
        }
         .fourbox p {
            margin: 20px 0;
        }
        .top-right{
            right: 63px;
    width: 120px;
    height: 120px;
    background: #0EBE2C;
    position: absolute;
    top: 94px;
        }
        .bottom-left{
                left: 81px;
    width: 120px;
    height: 120px;
    background: #0EBE2C;
    position: absolute;
    top: 274px;
        }
</style>